// removed by extract-text-webpack-plugin
module.exports = {"custom-dropdown":"custom-dropdown__TRVnz"};


//////////////////
// WEBPACK FOOTER
// ./components/form/dropdown/styles/CustomDropDown.scss
// module id = g5aD
// module chunks = 1